import 'jquery';
import Common from 'routes/common';

export default {
  init() {
    // JavaScript to be fired on all pages
    const $main = $('.main');

    $('blockquote:not([class*="blockquote-"])', $main).addClass('blockquote blockquote-quoted');
    $('a.shine', $main).removeClass('shine');
    $('> img:only-child', 'p').unwrap().wrap('<div class="mb-4"></div>');
    $('.nav-link[title]').removeAttr('title');

    // Call method from library
    Common.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Call method from library
    Common.finalize();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js